import React, { useEffect, useState } from "react";
import { Form, Table, Modal, Button } from "react-bootstrap";
import { formatDeuda } from "../../../../utils/utils";
import SimulacionPlanPago from "../../Convenios/Components/SimulacionPlanPago";
import BuscarDeudas from "../../Convenios/Components/BuscarDeudas";
import SelectPlan from "../../../../components/SelectPlan";

const defaultCuotas = 15;

const SimularPlan = ({ show, handleClose }) => {
  const [periodos, setPeriodos] = useState({});
  const [monto, setMonto] = useState({});
  const [total, setTotal] = useState({});
  const [cuotas, setCuotas] = useState({});
  const [deudas, setDeudas] = useState([]);
  
  const [showSimulacion, setShowSimulacion] = useState(false);
  const [simulacionpp, setSimulacionpp] = useState("");
  const [tipoPlan, setTipoPlan] = useState("");
  const [anticipo, setAnticipo] = useState("");
  const [cuotasRafam, setCuotasRafam] = useState({});

  useEffect(() => {
    deudas.forEach(e => {
      if (e?.legal?.length) {
        if (!cuotas[e.recurso + "-" + e.imponible]) {
          setCuotas({ ...cuotas, [e.recurso + "-" + e.imponible]: defaultCuotas });
        }
      }
    });

  }, [deudas]);

  useEffect(() => {
    if (Object.values(monto).length) {
      let result = Object.keys(monto)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (prev[recurso + "-" + imponible]) {
          return {
            ...prev,
            [recurso + "-" + imponible]: +prev[recurso + "-" + imponible] + +monto[current]
          };
        }
        else {
          return {
            ...prev,
            [recurso + "-" + imponible]: +monto[current]
          };
        }
      }, {});

      setTotal(result);
    }
  }, [monto]);

  useEffect(() => {
    if (Object.values(monto).length) {
      let result = Object.keys(monto)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (prev[recurso + "-" + imponible]) {
          return {
            ...prev,
            [recurso + "-" + imponible]: +prev[recurso + "-" + imponible] + +monto[current]
          };
        }
        else {
          return {
            ...prev,
            [recurso + "-" + imponible]: +monto[current]
          };
        }
      }, {});

      setTotal(result);
    }
  }, [monto]);

  const handleCuotas = (e) => {
    if (+e.target.value > 15) {
      e.target.value = 15;
      setCuotas({ ...cuotas, [e.target.name]: 15 });
    } else {
      setCuotas({ ...cuotas, [e.target.name]: e.target.value });
    }
  };

  const handlePeriodos = (e, valueMonto, periodo) => {
    if (e.target.checked) {
      setMonto({
        ...monto,
        [e.target.name]: monto[e.target.name] ? +Number(monto[e.target.name] + valueMonto).toFixed(2) : valueMonto
      });

      setCuotasRafam({
        ...cuotasRafam,
        [e.target.name]: cuotasRafam[e.target.name] ? [...cuotasRafam[e.target.name], periodo] : [periodo]
      });
    }
    else {
      setMonto({
        ...monto,
        [e.target.name]: monto[e.target.name] ? +Number(monto[e.target.name] - valueMonto).toFixed(2) : 0
      });

      setCuotasRafam({
        ...cuotasRafam,
        [e.target.name]: cuotasRafam[e.target.name] ? cuotasRafam[e.target.name].filter((p) => !(p.ANIO === periodo.ANIO && p.CUOTA === periodo.CUOTA)) : []
      });
    }
  };

  const handleYear = (e, periodosData, valueMonto) => {
    if (e.target.checked) {
      let checkboxs = document.getElementsByName([e.target.name]);
      checkboxs.forEach(p => p.checked = true);
      setPeriodos({
        ...periodos,
        [e.target.name]: periodosData.length
      });
      setMonto({
        ...monto,
        [e.target.name]: +valueMonto
      });

      setCuotasRafam({
        ...cuotasRafam,
        [e.target.name]: periodosData
      });
    }
    else {
      let checkboxs = document.getElementsByName([e.target.name]);
      checkboxs.forEach(p => p.checked = false);

      setMonto({
        ...monto,
        [e.target.name]: 0
      });

      setCuotasRafam({
        ...cuotasRafam,
        [e.target.name]: []
      });
    }
  };

  const handleRemove = (item) => {
    setDeudas(prev => {
      return prev.filter(e => !(e.recurso === item.recurso && e.imponible === item.imponible));
    });

    setTotal(prev => {
      delete prev[item.recurso + "-" + item.imponible];
      return prev;
    });

    setCuotas(prev => {
      delete prev[item.recurso + "-" + item.imponible];
      return prev;
    });

    if (Object.values(monto).length) {
      let result = Object.keys(monto)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (recurso === item.recurso && imponible === item.imponible) {
          return prev;
        }
        else {
          return {
            [current]: monto[current]
          };
        }
      }, {});

      setMonto(result);
    }

    if (Object.values(cuotasRafam).length) {
      let result = Object.keys(cuotasRafam)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (recurso === item.recurso && imponible === item.imponible) {
          return prev;
        }
        else {
          return {
            [current]: cuotasRafam[current]
          };
        }
      }, {});

      setCuotasRafam(result);
    }
  };

  const handleShowModal = (e) => {
    const { recurso, imponible } = e;

    if (!total[recurso + "-" + imponible]) return;
    if (!total[recurso + "-" + imponible]) return;
    if (tipoPlan[recurso + "-" + imponible] === "W2203" && !anticipo[recurso + "-" + imponible]) return;

    let jsdeuda = [];
    if (Object.values(cuotasRafam).length) {
      jsdeuda = Object.keys(cuotasRafam)?.reduce((prev, current) => {
        const [imp, rec] = current.split("-");

        if (rec === recurso && imp === imponible) {
          return [...prev, ...cuotasRafam[current]];
        }
        else {
          return prev;
        }
      }, []);
    }

    setSimulacionpp({
      ...e,
      total: total[recurso + "-" + imponible],
      cuotas: cuotas[recurso + "-" + imponible] || defaultCuotas,
      tipoPlan: tipoPlan[recurso + "-" + imponible],
      anticipo: anticipo[recurso + "-" + imponible],
      jsdeuda
    });
    setShowSimulacion(true);
  };

  const handleCloseModal = () => setShowSimulacion(false);

  return (
    <Modal
      animation={false}
      show={show}
      onHide={handleClose}
      size="xl"
      centered
    >
      <Modal.Header>
        <Modal.Title>Simulación Plan de Pago</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="buscar-deudas">
            <BuscarDeudas setDeudas={setDeudas} deudas={deudas} handleRemove={handleRemove} />
          </div>

          {deudas?.length ? deudas.map(({ imponible, recurso, legal }, i) => {

            return (
              <div key={imponible + recurso + i} style={{ width: "100%", padding: "2rem", overflow: "auto" }}>
                {legal?.length ? (
                  <Table
                    className="subtable legal-subtable"
                    striped
                    bordered
                    hover
                  >
                    <tbody>
                      <tr>
                        <td colSpan={3} className="subtable-subtitulo">Abogado ({legal[legal.length - 1].LEGAL}). Recurso: {recurso || ""} - Imponible: {imponible || ""}</td>
                      </tr>
                      <tr>
                        <td colSpan={3} className="subtable-subtitulo">Períodos Legal</td>
                      </tr>
                      <tr>
                        <td className="subtable-key">Año</td>
                        <td className="subtable-key">Período</td>
                        <td className="subtable-key">Monto</td>
                      </tr>
                      {formatDeuda(legal)?.length ?
                        formatDeuda(legal).map((deuda, indx) => {
                          let name = `${imponible}-${recurso}-${deuda.anio}-${indx}`;

                          return (
                            <tr key={"plan" + indx + recurso}>
                              <td className="subtable-key">
                                <div className="d-flex align-items-center ">
                                  <Form.Check
                                    name={name}
                                    value={deuda.anio}
                                    onChange={(e) => handleYear(e, deuda.periodos, deuda.monto.toFixed(2))}
                                  />
                                  <Form.Label className="" >{deuda.anio}</Form.Label>
                                </div>
                              </td>
                              <td className="d-flex" style={{ height: 54 }}>
                                {
                                  deuda?.periodos?.length ? deuda.periodos.map((periodo, i) => {
                                    return (
                                      <div className="d-flex align-items-center ml-3" key={deuda.anio + periodo?.CUOTA + i}>
                                        <Form.Check
                                          value={periodo?.CUOTA}
                                          name={name}
                                          className=""
                                          onChange={(e) => handlePeriodos(e, +Number(periodo?.TOTAL).toFixed(2), periodo)}
                                        />
                                        <Form.Label className="" >{periodo?.CUOTA}</Form.Label>
                                      </div>
                                    );
                                  })
                                    : null
                                }
                              </td>
                              <td className="subtable-key">$ {monto[name] ? monto[name] : 0}</td>
                            </tr>
                          );
                        }) : null}
                      <tr>
                        <td colSpan={2} className="subtable-key" style={{ textAlign: "right" }}>Total</td>
                        <td className="subtable-key">$ {total[recurso + "-" + imponible] ? total[recurso + "-" + imponible] : 0}</td>
                      </tr>
                      <tr>
                        <td colSpan={3} className="subtable-key" style={{ textAlign: "right" }}>
                          <SelectPlan
                            recurso={recurso}
                            imponible={imponible}
                            handleShowModal={handleShowModal}
                            handleCuotas={handleCuotas}
                            setCuotas={setCuotas}
                            setTipoPlan={setTipoPlan}
                            tipoPlan={tipoPlan}
                            setAnticipo={setAnticipo}
                            anticipo={anticipo}
                            total={total[recurso + "-" + imponible] ? total[recurso + "-" + imponible] : 0}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                ) : null}

              </div>
            );
          }) : null}

          {showSimulacion ? <SimulacionPlanPago show={showSimulacion} handleClose={handleCloseModal} data={simulacionpp} /> : null}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button onClick={handleClose} className="mr-3">
            Volver
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default SimularPlan;
